const trainingInitialState = {
  trainingCenters: [],
  sportItems: [],
  gameCardItems: []
};

export default trainingInitialState;
